// Client-side, engine-faithful overlap check for IN-GRID greying feedback ONLY.
// Availability truth still comes from /api/slots/public-availability (regions_overlap)
// and is enforced server-side at hold/booking. This mirrors the same divisible-turf
// geometry the backend region_map uses, expressed as atomic quarter-cells.
//
// Canonical regions (Depot18-style): full ⊇ {north,south}; north ⊇ {NE,NW};
// south ⊇ {SE,SW}; quarters/5-asides map to a single quarter cell.

const CELLS = { ne: 'ne', nw: 'nw', se: 'se', sw: 'sw' };

export function regionCells(region) {
  if (!region) return new Set();
  const r = String(region).toLowerCase();
  if (r === 'full') return new Set(['ne', 'nw', 'se', 'sw']);
  if (r === 'north') return new Set(['ne', 'nw']);
  if (r === 'south') return new Set(['se', 'sw']);
  if (r.includes('north-east') || r.endsWith('-ne') || r === 'ne') return new Set(['ne']);
  if (r.includes('north-west') || r.endsWith('-nw') || r === 'nw') return new Set(['nw']);
  if (r.includes('south-east') || r.endsWith('-se') || r === 'se') return new Set(['se']);
  if (r.includes('south-west') || r.endsWith('-sw') || r === 'sw') return new Set(['sw']);
  // Independent surface (padel/pickle/box-cricket-in-own-tree/etc.) — overlaps only itself.
  return new Set([`self:${r}`]);
}

// Do two regions physically overlap (share any atomic cell)?
export function regionsOverlapClient(a, b) {
  if (!a || !b) return false;
  if (a === b) return true;
  const ca = regionCells(a);
  const cb = regionCells(b);
  for (const c of ca) if (cb.has(c)) return true;
  return false;
}
